// Timer.js
var Timer = pc.createScript('timer');

Timer.attributes.add('Timetext',{type: 'entity'});

Timer.prototype.initialize = function() {
    
    Timer.instance = this;
    this.timerContinue = false;
    this.percent = 0;
    this.entity.on("destroy", this.OnDestroy,this);
};


Timer.prototype.StartTimer = function(duration){
    
    //this.percent = duration * 10 / 100;
    this.percent = 5;
    var timerr = duration, minutes, seconds;
    timer = timerr;
    this.stopInterval = setInterval(this.TimeCounter, 1000);
    this.intervalId = this.stopInterval;
    this.timerContinue = true;
    this.app.fire('timeBar:start',duration);
};


Timer.prototype.StopTimer = function(){
    
    this.timerContinue=false;
    clearInterval(this.intervalId);
    TimeBar.instance.pauseBar();
};

Timer.prototype.PauseTimer = function() {
    this.timerContinue=false;
};

Timer.prototype.ContinueTimer = function() {
    this.timerContinue=true;
};

Timer.prototype.timeFormat = function(timerVal) {

    Timer.instance.Timetext.setLocalScale(1,1,1);
    this.timerContinue=false;
    
    minutes = parseInt(timerVal / 60, 10);
    seconds = parseInt(timerVal % 60, 10);
    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;
    Timer.instance.Timetext.element.text = minutes + ":" + seconds;
};

Timer.prototype.TimeCounter = function(){

    if (Timer.instance.timerContinue)
    {
        if (timer <= 0) {
            //console.log("Time's Up");
            SoundManager.instance.stopSound('TimeRunning');

            if (PlayerManager.instance.userData.gameMode == gamePlayMode.Normal || PlayerManager.instance.userData.gameMode == gamePlayMode.Places) {
                let minObjectCount = PlayerManager.instance.userData.gameMode == gamePlayMode.Normal ? PlayerManager.instance.levelData.minObjectCount : GameManager.instance.placeData.minObjectCount;

                if ((matchObjectCounter >= minObjectCount) && (matchThemAllButtonClick == false)) {
                    if (spawnPositions[0].children.length > 0) {
                        MatchThemAllAnimation.instance.startAnimation();
                        // if (gdsdk !== 'undefined' && gdsdk.preloadAd !== 'undefined') {
                        //     gdsdk
                        //         .preloadAd('rewarded')
                        //         .then(response => {


                        //             MatchThemAllAnimation.instance.startAnimation();
                        //         })
                        //         .catch(error => {
                        //             Timer.instance.levelEnding();
                        //         });
                        // }
                        if (gdsdk !== 'undefined' && gdsdk.preloadAd !== 'undefined') {
                            gdsdk.preloadAd();
                        }
                    }
                    else {
                        Timer.instance.levelEnding();
                    }
                }
                else {
                    Timer.instance.levelEnding();
                }
            }
            else {
                Timer.instance.levelEnding();
            }
        }
        else {

            if(timer <= Timer.instance.percent){
                GameUi.instance.showHideHomeButton(false);
                SoundManager.instance.playSound('TimeRunning');
                Timer.instance.Timetext.tween(Timer.instance.Timetext.getLocalScale()).to(new pc.Vec3(1, 1, 1), 0.5, pc.SineOut).on('complete', function(){
                    Timer.instance.percentAnim();
                },this).start();
            }

            timer--;
            minutes = parseInt(timer / 60, 10);
            seconds = parseInt(timer % 60, 10);
            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;
            Timer.instance.Timetext.element.text = minutes + ":" + seconds;
            _remainTime=timer;
        }
    }
};

Timer.prototype.levelEnding = function () {

    if (PlayerManager.instance.userData.gameMode == gamePlayMode.Normal || PlayerManager.instance.userData.gameMode == gamePlayMode.Places) {

        let minObjectCount = PlayerManager.instance.userData.gameMode == gamePlayMode.Normal ? PlayerManager.instance.levelData.minObjectCount : GameManager.instance.placeData.minObjectCount;

        if (matchObjectCounter >= minObjectCount) {
            Timer.instance.StopTimer();
            SoundManager.instance.playSound('WinSound');
            //GAADSManager.instance.showInterstitial();
            GameManager.instance.GameWin();
            //ADSManager.instance.OpenRewardVideo(adsEnum.Interstitial, adsGameFinishEnum.Win);
        }
        else {
            Timer.instance.StopTimer();
            SoundManager.instance.playSound('LoseSound');
            //GAADSManager.instance.showInterstitial();
            GameManager.instance.GameLose();
            //ADSManager.instance.OpenRewardVideo(adsEnum.Interstitial, adsGameFinishEnum.Lose);
        }
    }
    else {
        Timer.instance.StopTimer();
        SoundManager.instance.playSound('LoseSound');
        GameManager.instance.GameLose();
        //ADSManager.instance.OpenRewardVideo(adsEnum.Interstitial, adsGameFinishEnum.Lose);
    }
};

Timer.prototype.extraTime = function() {

    this.StopTimer();

    Timer.instance.Timetext.setLocalScale(1,1,1);
    
    let ekstraTime = this.percent;
    ekstraTime = 30;
    timeBarTotalTime = ekstraTime;

    this.timeFormat(ekstraTime);
    this.StartTimer(ekstraTime);
    TimeBar.prototype.continueBar();
};


Timer.prototype.percentAnim = function(){
    if(timer !== 0){
        Timer.instance.Timetext.tween(Timer.instance.Timetext.getLocalScale()).to(new pc.Vec3(0, 0, 0), 0.5, pc.SineOut).start();
    }
    else{
        Timer.instance.Timetext.tween(Timer.instance.Timetext.getLocalScale()).to(new pc.Vec3(1, 1, 1), 0.5, pc.SineOut).start();
    }
};

Timer.prototype.OnDestroy = function(){
    this.entity.off("destroy", this.OnDestroy,this);
};


